import { EnvironmentFilled } from "@ant-design/icons";
import { Alert, Divider, Text } from "../components";
import { Branch, CartItem } from "../types/item";
import { TotalsInput } from "../utils/totals";
import Cart from "./cart";
import { ReactNode } from "react";
import React from "react";

const Summary = ({
  items,
  totals,
  children,
  branch,
}: {
  items: CartItem[];
  totals?: TotalsInput;
  children?: ReactNode;
  branch?: Branch | null;
}) => (
  <>
    <div
      className="p-24-h p-24-v"
      children={React.Children.toArray(
        items.map((item, index) => (
          <>
            {!!index && <Divider className="m-15-v" />}
            <Cart.Item
              {...item}
              editable={false}
              totalPrice={
                item.lineTotal ??
                item.totalPrice ??
                (Number(item.unitPrice ?? item.price) || 0) * item.quantity
              }
            />
          </>
        )),
      )}
    />
    <Divider className="m-0" />
    <div className="p-24">
      <Cart.Footer
        className="!border-0"
        classNames={{ body: "p-0" }}
        totals={totals}
      />
      {!!branch?.uuid && (
        <Alert
          showIcon
          type="warning"
          className="m-20-t"
          icon={<EnvironmentFilled className="text-[30px]" />}
          onClick={() => {
            window.open(
              "https://www.google.com/maps/search/?api=1&query=" +
                encodeURIComponent(branch?.address ?? ""),
              "_blank",
            );
          }}
          message={[
            `This is a pickup order please Collect from `,
            <Text level="link" strong children={branch?.name} />,
            ` branch, Address: `,
            <Text level="link" strong children={branch?.address} />,
            " or click here to open in Maps",
          ]}
        />
      )}
      {children}
    </div>
  </>
);

export default Summary;
